import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, isAnalyticsEnabled } from '../utils/analytics';

export function usePageTracking(): void {
  const location = useLocation();

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;
    trackPageView(location.pathname, document.title);
  }, [location.pathname]);
}
